import React, { useEffect, useState } from "react";
import {
 deleteItem,
 deleteMultipleItem,
 fetchData,
} from "../../../utils/apiUtils";
import DeleteModel, {
 confirmBulkDelete,
} from "../../../Components/DeleteModel";
import {
 ActionButton,
 checkImage,
 DeleteButton,
} from "../../../helper/ImageFormat";
import { toast } from "react-toastify";
import axiosInstance, { cdnInstance } from "../../../axiosInterceptor";
import Breadcrumb from "../../../helper/Breadcrumb";
import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import { getAllImages } from "../../../helper/getAllImages";

const DraftCatalogue = () => {
 const [loading, setLoading] = useState(false);
 const [tempcatalogData, settempcatalogData] = useState([]);
 const [currentPage, setCurrentPage] = useState(1);
 const [deleteItemId, setDeleteItemId] = useState({});
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [perPage, setPerPage] = useState(50);
 const [isDeleting, setIsDeleting] = useState(false);
 const [totalCount, setTotalCount] = useState(0);
 const [selected, setSelected] = useState([]);
 const [search, setSearch] = useState("");

 useEffect(() => {
  const delay = search ? 500 : 0;

  const handler = setTimeout(() => {
   fetchTemppCatelogData(1, search);
  }, delay);

  return () => clearTimeout(handler);
 }, [search, perPage]);

 const fetchTemppCatelogData = async (page = 1, searchQuery = "") => {
  const requestData = { perPage: perPage, pageNo: page, search: searchQuery };
  await fetchData(
   "draft-pagination",
   requestData,
   settempcatalogData,
   setTotalCount,
   setCurrentPage,
   setLoading
  );
 };

 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };
 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem(
    "draft",
    deleteItemId?.id,
    fetchTemppCatelogData,
    [deleteItemId?.coverImage]
   );
   const imagesToDelete = getAllImages(deleteItemId);
   await Promise.all(
    imagesToDelete.map((img) =>
     cdnInstance.delete("/delete-product", { data: img })
    )
   );

   setDeleteItemId(null);
   setDeleteModalOpen(false);
   return res;
  } catch (err) {
   throw err;
  } finally {
   setIsDeleting(false);
  }
 };
 const handleEditClick = async (data) => {
  try {
   const response = await axiosInstance.put(`/draft-restore/${data?.id}`);
   if (response.status === 200) {
    const { data } = response;
    toast.success(data?.message);
    fetchTemppCatelogData();
   }
  } catch (error) {
   toast.success(error?.response?.data?.message);
  }
 };
 const Tableheader = [
  "Cover Image",
  "Category",
  "Name",
  "SKU",
  "Price",
  "Average Price",
  "Offer Price",
  "Auto Delete On",
  "Action",
 ];

 const getFutureDate = (timestamp) => {
  const deletedDate = new Date(timestamp);
  deletedDate.setHours(deletedDate.getHours() + 48);
  return deletedDate.toLocaleString();
 };

 const handleBulkDelete = async () => {
  await confirmBulkDelete({
   itemType: "Sizes",
   selectedIds: selected,
   deleteApiCall: (ids) => deleteMultipleItem("draft-bulk-delete", ids),
   refreshCallback: fetchTemppCatelogData,
  });
 };

 const totalPages = Math.ceil(totalCount / perPage);
 const handlePageClick = (page) => {
  if (page >= 1 && page <= totalPages) {
   fetchTemppCatelogData(page);
  }
 };

 const isAllSelected =
  tempcatalogData.length > 0 && selected.length === tempcatalogData.length;
 const toggleSelectAll = () =>
  setSelected(isAllSelected ? [] : tempcatalogData.map((i) => i.id));
 const toggleSelectOne = (id) =>
  setSelected((prev) =>
   prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
  );

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Draft Catalogue", path: "/" },
 ];
 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-5">
     <h3 className="custom-page-title">Draft Catalogue</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div
     className="d-flex justify-content-between mb-3"
     style={{ background: "#fff", padding: "10px" }}
    >
     <PerPageSelect value={perPage} onChange={setPerPage} />

     <div style={{ display: "flex", gap: "20px" }}>
      <TableSearch value={search} onChange={setSearch} />
      {selected.length > 0 && (
       <DeleteButton
        handleAdd={handleBulkDelete}
        name="selected Catalogue"
        module={"Draft Catalogue"}
       />
      )}
     </div>
    </div>

    <div className="row" style={{ marginTop: "-10px" }}>
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <div className="table-responsive rounded p-1">
         <table
          className="custom-table table table-striped"
          id="DraftCatalogue"
         >
          <thead>
           <tr>
            <th>
             <input
              type="checkbox"
              checked={isAllSelected}
              ref={(el) => {
               if (el) el.indeterminate = selected.length > 0 && !isAllSelected;
              }}
              onChange={toggleSelectAll}
             />
            </th>
            {Tableheader &&
             Tableheader?.map((item, index) => (
              <th key={index} className="font-weight-bold text-center">
               {item}
              </th>
             ))}
           </tr>
          </thead>
          <tbody>
           {loading ? (
            <tr>
             <td colSpan="11" className="text-center">
              <Spinner />
             </td>
            </tr>
           ) : tempcatalogData && tempcatalogData?.length > 0 ? (
            tempcatalogData.map((item, index) => {
             return (
              <tr key={index}>
               <td>
                <input
                 type="checkbox"
                 checked={selected.includes(item.id)}
                 onChange={() => toggleSelectOne(item.id)}
                />
               </td>
               <td className="text-center">{checkImage(item.coverImage)}</td>
               <td className="text-center">
                {item.categories?.length
                 ? item.categories.map((cat) => cat.name).join(", ")
                 : "No Category"}
               </td>

               <td className="text-center ">{item.name.slice(0, 50)}...</td>
               <td className="text-center">{item.cat_code} </td>
               <td className="text-center">{item.price}</td>
               <td className="text-center">{item.average_price}</td>
               <td className="text-center">{item.offer_price}</td>

               <td className="text-center">
                {" "}
                {item.deletedAt
                 ? getFutureDate(item.deletedAt)
                 : "No date available"}
               </td>

               <td className="text-center">
                <ActionButton
                 data={item}
                 editicon="fa-solid fa-arrows-rotate"
                 edittitle="Restore"
                 handleEditClick={handleEditClick}
                 handleDelete={handleDelete}
                 module={"Draft Catalogue"}
                />
               </td>
              </tr>
             );
            })
           ) : (
            <tr>
             <td colSpan="12" className="text-center">
              <h4>No data available</h4>
             </td>
            </tr>
           )}
          </tbody>
         </table>
        </div>
        {tempcatalogData?.length > 0 && (
         <div>
          <CustomPagination
           currentPage={currentPage}
           totalPages={totalPages}
           onPageChange={handlePageClick}
           perPage={perPage}
           totalCount={totalCount}
          />
         </div>
        )}
       </div>
      </div>
     </div>
    </div>
   </div>

   {deleteModalOpen && (
    <DeleteModel
     deleteModalOpen={deleteModalOpen}
     setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
     onConfirm={confirmDelete}
     itemName="Catalogue"
     isDeleting={isDeleting}
    />
   )}
  </>
 );
};

export default DraftCatalogue;
